module.exports = __webpack_public_path__ + "img/fact-sheet.db0f6ebf.svg";